document.addEventListener('DOMContentLoaded', function () {
  var areaHeaders = document.querySelectorAll('.page-shipping .table04 tbody th.area');

  areaHeaders.forEach(function (header) {
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', 'false');
  });

  function toggleShippingRow(header) {
    if (window.matchMedia('(min-width: 600px)').matches) return;

    var row = header.closest('tr');
    if (!row) return;

    var willOpen = !header.classList.contains('active');
    header.classList.toggle('active', willOpen);
    header.setAttribute('aria-expanded', String(willOpen));

    row.querySelectorAll('td').forEach(function (cell) {
      cell.classList.toggle('tdactive', willOpen);
    });
  }

  document.addEventListener('click', function (event) {
    var header = event.target.closest('.page-shipping .table04 tbody th.area');
    if (header) toggleShippingRow(header);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var header = event.target.closest('.page-shipping .table04 tbody th.area');
    if (!header) return;

    event.preventDefault();
    toggleShippingRow(header);
  });
});
